const LANGUAGE_STORAGE_KEY = 'language';
const USER_SET_LANGUAGE_KEY = 'language-user-set';
const AVAILABLE_LANGUAGES = ['en', 'pt-BR'] as const;
type Language = typeof AVAILABLE_LANGUAGES[number];
const DEFAULT_LANGUAGE: Language = 'pt-BR';

export function getStoredLanguage(): Language {
  try {
    const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
    const userSetFlag = localStorage.getItem(USER_SET_LANGUAGE_KEY);

    if (!userSetFlag) {
      localStorage.setItem(USER_SET_LANGUAGE_KEY, 'true');
      localStorage.setItem(LANGUAGE_STORAGE_KEY, DEFAULT_LANGUAGE);
      return DEFAULT_LANGUAGE;
    }

    if (!stored || !AVAILABLE_LANGUAGES.includes(stored as Language)) {
      return DEFAULT_LANGUAGE;
    }

    return stored as Language;
  } catch {
    return DEFAULT_LANGUAGE;
  }
}

export function setStoredLanguage(language: Language): void {
  try {
    if (!AVAILABLE_LANGUAGES.includes(language)) {
      return;
    }
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    localStorage.setItem(USER_SET_LANGUAGE_KEY, 'true');
  } catch {
    // Silently handle storage errors
  }
}

export function clearStoredLanguage(): void {
  try {
    localStorage.removeItem(LANGUAGE_STORAGE_KEY);
    localStorage.removeItem(USER_SET_LANGUAGE_KEY);
  } catch {
    // Silently handle storage errors
  }
}
